import { Card } from "@compass/core";
import { LkPersonType } from "generated/openApi";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { pillToggleGroupStyles } from "pages/HomePage/styles/segmentedControlStyles";

export const PersonTypeTabs = (props: {
  personTypes: LkPersonType[];
  value: number;
  onChange: (value: number) => void;
}) => {
  return (
    <Card
      sx={{
        flexShrink: 0,
        borderRadius: "50px",
        bgcolor: (theme) => theme.palette.background.default,
        overflow: "hidden",
      }}
      bodySx={{
        p: 0,
        bgcolor: (theme) => theme.palette.background.default,
      }}
    >
      <ToggleButtonGroup
        value={props.value}
        exclusive
        onChange={(e, value) => {
          if (!value || value === props.value) return;

          props.onChange(value);
        }}
        sx={pillToggleGroupStyles}
      >
        {props.personTypes.map((personType) => (
          <ToggleButton key={personType.id} value={personType.id}>
            {personType.name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Card>
  );
};
